module.exports = __webpack_public_path__ + "static/media/lottery-prizes-routes@2x.daa80e5f.png";